import {React, styled} from 'common'
import {useEffect, useMemo} from 'react'
import {useFieldArray, useFormContext} from 'react-hook-form'
import FromArrayElement from './FromArrayElement'
import {IconButton} from '@mui/material'
import AddRoundedIcon from '@mui/icons-material/AddRounded'

const FormArray = ({
    arrayName,
    Component,
    fieldsComponent,
    appendOnEmpty = true,
    withButtons,
    ...p
}) => {
    const {control} = useFormContext()
    //prepend , swap , move , insert
    const {fields, append, remove} = useFieldArray({
        control,
        name: arrayName,
    })

    const defaultValue = useMemo(
        () => Object.keys(fieldsComponent).reduce((acc, key) => ({...acc, [key]: null}), {}),
        [fieldsComponent]
    )

    const appendHandler = () => {
        append(defaultValue)
    }
    useEffect(() => {
        if (appendOnEmpty && fields?.length === 0) {
            append(defaultValue)
        }
    }, [fields, append, defaultValue, appendOnEmpty])

    const ArrayComponent = useMemo(() => Component || FromArrayElement, [Component])

    return (
        <Container>
            {withButtons && fields.length === 0 && (
                <EmptyActions>
                    <IconButton onClick={appendHandler} sx={{width: '32px', height: '32px'}}>
                        <AddRoundedIcon sx={{width: '16px', height: '16px'}} />
                    </IconButton>
                </EmptyActions>
            )}
            {fields.map((field, index) => (
                <ArrayComponent
                    key={field.id}
                    arrayName={arrayName}
                    index={index}
                    fields={fieldsComponent}
                    append={appendHandler}
                    remove={() => remove(index)}
                    style={{flexDirection: 'row'}}
                    i18n={arrayName}
                    isAddButton={fields.length - 1 === index}
                    withButtons={withButtons}
                    {...p}
                />
            ))}
        </Container>
    )
}

export default FormArray

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const EmptyActions = styled.div`
    display: flex;
    justify-content: flex-start;
`
